import { render, staticRenderFns } from "./ImageZoom.vue?vue&type=template&id=6c377dfc&scoped=true&"
import script from "./ImageZoom.vue?vue&type=script&lang=ts&"
export * from "./ImageZoom.vue?vue&type=script&lang=ts&"
import style0 from "./ImageZoom.vue?vue&type=style&index=0&id=6c377dfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c377dfc",
  null
  
)

export default component.exports